/**
 * @author ydoni
 * @description organization name 입력 시 bubble
 */
import styled from "styled-components";
import InfoBubble from "./InfoBubble";
import { FLEX } from "styles/flex";
import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import { orgNameRules } from "utils/regEx";
import WARNING_ICON from "assets/icons/warning_red.svg";
import ONLINE_ICON from "assets/icons/online.svg";

type Props = {
  password: string;
};

function OrgNameBubble({ password }: Props): JSX.Element {
  return (
    <InfoBubble>
      <Text fontSize={15} bold color={COLORS.WHITE}>
        Organization name must contain:
      </Text>
      <OrgNameList>
        {orgNameRules.map((rule) => (
          <OrgNameText key={rule.label}>
            <img
              src={rule.condition(password) ? WARNING_ICON : ONLINE_ICON}
              alt=""
            />
            {rule.label}
          </OrgNameText>
        ))}
      </OrgNameList>
    </InfoBubble>
  );
}

const OrgNameList = styled.ul`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 6px;
  padding: 8px 0;
  text-align: left;
`;

const OrgNameText = styled.li`
  ${FLEX.FlexStartCenter};
  gap: 6px;
  font-size: ${calcRem(13)};

  > img {
    width: 15px;
    height: 15px;
  }
`;

export default OrgNameBubble;
